import Toastify from 'toastify-js';
import {
  getAttribution,
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import { apiRequest } from '@common/api/utils';
import { Modal } from '@common/vanilla_ui/general';

const modalId = 'events-application-modal';
const modalEl = document.getElementById(modalId);

const APP_INTERVIEWBIT = 'interviewbit';
const APP_SCALER = 'scaler';
// eslint-disable-next-line camelcase
const appId = window?.ENV_VARS?.application?.env_id || APP_SCALER;

function registerEvent() {
  const registerBtnClass = '.card-list__register';
  const registerBtnAll = document.querySelectorAll(registerBtnClass);

  const checkParams = (conditions = {}) => {
    const params = new URLSearchParams(window.location.search);
    return Object.entries(conditions).every((entry) => {
      const [key, value] = entry;
      return params.get(key) === value;
    });
  };

  const formStatusTracking = (status, attributes) => {
    window.GTMtracker.pushEvent({
      event: 'gtm_custom_click',
      data: {
        ...attributes,
        form_status: status,
      },
    });
  };

  const setToastifyClass = (toastType) => {
    let shiftToastifyClass = '';
    if (checkParams({ iframe: 'true' })) {
      shiftToastifyClass = 'scaler-event__toastify-shift';
    }

    return `toastify-${toastType} ${shiftToastifyClass}`;
  };

  const submitForm = async (e, data, proceedTo, successAction) => {
    e.preventDefault();
    const payload = {
      phone_number: data.phoneNumber,
      email: data.email,
      attributions: getAttribution(),
    };
    let message = 'Something went wrong! Reload the page and try again';
    const scalerApplyUrl = `/apply/event/${data.slug}`;
    const actionUrl = scalerApplyUrl;
    try {
      const json = await apiRequest('POST', actionUrl, payload);
      if (json?.success) {
        successAction(json);
        window.registered = 'true';
        window.open(proceedTo, '_blank');
        if (json.metadata) {
          const { gtm_data: gtmData } = json.metadata;
          window.TrackingHelper?.pushEvent(gtmData);
        }
        formStatusTracking(true,
          {
            success_message:
            'Successfully register for event',
          });
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        message = 'Phone number associated with another account';
      } else if (error.response && error.response.status === 403) {
        // eslint-disable-next-line max-len
        message = 'Your email is already registered, click here to login instead.';
      } else if (error.response && error.response.status === 422) {
        message = error?.responseJson?.message || 'Please fill all fields';
        if (window.recaptchaResponseHash['event-auth-recaptcha']) {
          window.grecaptcha?.reset(
            window.recaptchaResponseHash['event-auth-recaptcha'],
          );
        }
      } else if (error?.responseJson?.message) {
        message = error.responseJson.message;
      }

      formStatusTracking(false,
        {
          error_message: message,
        });

      Toastify({
        text: message,
        className: setToastifyClass('danger'),
      }).showToast();
    }
  };

  const handleFormSubmit = async (e, data, proceedTo) => {
    e.preventDefault();
    submitForm(e, data, proceedTo, () => {
      Toastify({
        text: 'You are successfully registered for the event',
        className: setToastifyClass('success'),
      }).showToast();
      if (appId === APP_INTERVIEWBIT) {
        window.location.reload();
      }
    });
  };

  registerBtnAll.forEach(register => {
    register.addEventListener('click', (el) => {
      el.preventDefault();
      el.stopPropagation();
      const dataSlug = register.getAttribute('data-event-slug');
      const phoneVerified = register.getAttribute('data-phone-verified');
      const registered = register.getAttribute('data-registered');
      const proceedTo = register.getAttribute('data-proceed');
      const dataPhone = register.getAttribute('data-phone');
      const formId = 'events-application-form-phone';
      const formEl = document.getElementById(formId);
      const emailEl = formEl.querySelector('.events-application-form__email');
      const email = emailEl.querySelector(
        '#events-application-form-email',
      ).value;

      const eventSlugsEl = modalEl.querySelectorAll(
        '[data-event-slug]',
      );
      eventSlugsEl.forEach(element => {
        element.setAttribute('data-event-slug', dataSlug);
      });

      const data = {
        phoneNumber: dataPhone,
        slug: dataSlug,
        email,
      };

      const isOneClickRegister = formEl.checkValidity();
      const boolPhoneVerified = phoneVerified === 'false'
        ? false : Boolean(phoneVerified);
      if (registered === 'true') {
        window.open(proceedTo, '_blank');
      } else if (boolPhoneVerified && isOneClickRegister) {
        setAttribution('event_register');
        handleFormSubmit(el, data, proceedTo);
      } else if (modalEl) {
        modalEl.classList.remove('hidden');
        Modal.open(modalId);
      }
    });
  });
}

export default {
  initialize: registerEvent,
};
